import { render } from "./RIFCard.vue?vue&type=template&id=09fe3736&scoped=true"
import script from "./RIFCard.vue?vue&type=script&lang=js"
export * from "./RIFCard.vue?vue&type=script&lang=js"

import "./RIFCard.vue?vue&type=style&index=0&id=09fe3736&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fe3736"]])

export default __exports__